import { LTSimpleAnimator } from "../../LTGame/Anim/LTSimpleAnimator";
export var EAnimType;
(function (EAnimType) {
    EAnimType[EAnimType["Idle"] = 0] = "Idle";
    EAnimType[EAnimType["Fight"] = 1] = "Fight";
    EAnimType[EAnimType["Fighted"] = 2] = "Fighted";
})(EAnimType || (EAnimType = {}));
export default class CameraControl {
    InitCamera(obj, light) {
        this._rootObj = obj;
        this.light = light;
        let anim = this._rootObj.getChildAt(0);
        this.bodyAnim = new LTSimpleAnimator(anim.getComponent(Laya.Animator));
        this.camera = anim.getChildAt(0);
        this.bodyAnim.updateImd = true;
        this.SetAnim(EAnimType.Idle);
        this.camera.farPlane = 300;
    }
    SetAnim(type) {
        switch (type) {
            case EAnimType.Idle:
                this.bodyAnim.targetAnimName = "pos_02";
                break;
            case EAnimType.Fight:
                this.bodyAnim.targetAnimName = "move";
                break;
            case EAnimType.Fighted:
                this.bodyAnim.targetAnimName = "move_02";
                break;
        }
    }
    SetFrom(root) {
        this._fromTarget = root;
        this.SyncPos();
    }
    TurnOn() {
        this.camera.enableRender = true;
        this.light.active = true;
    }
    TurnOff() {
        this.camera.enableRender = false;
        this.light.active = false;
    }
    SyncPos() {
        let old = this._rootObj.transform.position;
        old.z = this._fromTarget.transform.position.z;
        this._rootObj.transform.position = old;
    }
    LateUpdate(dt) {
        if (this._fromTarget) {
            this.SyncPos();
        }
    }
}
